module.exports = __webpack_public_path__ + "static/img/101683.f08b3c45.png";